import { Folder,Account, Dataset, JobType, TransformGroup, Job } from "4d-mapper"
import { Observable, throwError, of, combineLatest, Subscription } from "rxjs"

import { map, tap, filter } from "rxjs/operators"
import { BaseEvent, ArrayStore, Store } from 'vasat/dist/src/veflux'

import { MapDataService } from "../map-data.service"
import { StreamDataService } from "../stream-data.service"
import { Injectable } from "@angular/core"


@Injectable()
export class TreeNodeBuilder{
    constructor(protected _streams:StreamDataService){}

    get streams(){
        return this._streams
    }

    fromFolder(f:Folder){
        return new FolderNode(f).setBuilder(this)
    }
    fromAccount(a:Account){
        return new AccountNode(a).setBuilder(this)
    }
    fromAccountProjects(a:Account){
        return new ProjectsNode(a).setBuilder(this)
    }
    fromFolderWithFiles(f:Folder,expanded:boolean = false,selectabledFiles:boolean = false){
        return new FolderFileNode(f,expanded,selectabledFiles).setBuilder(this)
    }
    fromJobType(f:JobType,mapData:MapDataService){
        return new JobTypeNode(f,mapData).setBuilder(this)
    }
    fromJob(f:Job){
        return new JobNode(f).setBuilder(this)
    }
    fromFile(f:Dataset,selectable:boolean = false){
        return new FileNode(f,selectable).setBuilder(this)
    }
    fromStaticInfo(name:string,items:TreeNode[],expand:boolean = true){
        return new StaticNode(name,items,expand).setBuilder(this)
    }
    
}
/**
 * tree node is a wrapper for anything you want put in a tree
 */
export class TreeNode{
    constructor(public caption:string, public expanded:boolean = false,public ref:any, public selectable:boolean = false){}

    private _children = new ArrayStore(TreeEvent)
    protected _subs:Subscription[] = []
    protected _builder:TreeNodeBuilder
    protected _refdraw:(TreeEvent) => any
    icon:string
    
    set redraw(fn:(TreeEvent) => any){
        this._refdraw = fn
    }
    get children(){
        return this._children
    }
    get isLeaf():boolean{ return false }
    get hasChildren():boolean{ return false }

    setBuilder(tnb:TreeNodeBuilder){
        this._builder = tnb
        return this
    }
    load(){}
    unload(){
        this._subs.forEach(s => s.unsubscribe())
    }
    loadChildren():Observable<any>{
        throw new Error('not Implemented')
    }

}


class StaticNode extends TreeNode{
    constructor(name:string, private byoChildren:TreeNode[], expand:boolean){
        super(name,expand,name)
    }
    get isLeaf():boolean{ return false }
    get hasChildren():boolean{ return this.byoChildren.length > 0 }
    loadChildren(){
        return of(this.byoChildren).pipe(tap(c => 
            this.children.values = c
        ))
    }

}


class AccountNode extends TreeNode{
    constructor(private a:Account){
        super(a.name,true,a)
    }
    loadChildren(){
        return this.a.vasat.searchByObject(Folder)
            .equals("account",this.a.id)
            .equals("active",true)
            .isNull("forProject")
            .isNull("parent")
            .useCache(true)
            .limit(100)
            .queryObservable().pipe(map(r => 
                this.children.values = r.items.map(i => this._builder.fromFolder(i))   
            ))
    }
    get hasChildren():boolean{ return true }
}


class ProjectsNode extends TreeNode{
    constructor(private a:Account){
        super(a.name,false,a)
    }
    loadChildren(){
        return this.a.vasat.searchByObject(Folder)
            .equals("account",this.a.id)
            .equals("active",true)
            .isNotNull("forProject")
            .useCache(true)
            .limit(100)
            .queryObservable().pipe(map(r => 
                this.children.values = r.items.map(i => this._builder.fromFolder(i))   
            ))
    }
    get hasChildren():boolean{ return true }
}

class FolderNode extends TreeNode{
    constructor(protected f:Folder,expanded:boolean = false){
        super(f.name,expanded,f)

    }
    load(){
        this._subs.push(this._builder.streams.folderEvents.pipe(filter(f => f.item == this.f)).subscribe(f => {
            this.caption = f.item.name
            if(this._refdraw) this._refdraw(f)            
        }))
    }
    protected initChildListener(){
        this._subs.push(this._builder.streams.folderEvents.pipe(filter(f => f.item.parent.id == this.f.id && this.hasChildren)).subscribe(f => {
            if(f.event == 'ADD'){
                this.children.add(this._builder.fromFolder(f.item))
            }
            else if(f.event == 'REMOVE'){
                this.children.values = this.children.values.filter(c => c.ref != f.item)
            }
        }))
    }
    loadChildren(){
        
       this.initChildListener()
      

        return this.f.vasat.searchByObject(Folder)
            .equals('parent',this.f.id)
            .equals('active',true)
            .useCache(true)
            .sortBy('name')
            .queryObservable().pipe(map(r => 
                this.children.values = r.items.map(i => this._builder.fromFolder(i))
            ))
    }
    get hasChildren():boolean{ return this.f['folder_count'] }
}

/**
 * Contains both sub folders and files in the tree
 */
export class FolderFileNode  extends FolderNode{
    constructor(f:Folder,expanded:boolean, protected selectableFiles:boolean = false){
        super(f,expanded)
    }
    loadChildren(){
        this.initChildListener()

        this._subs.push(this._builder.streams.fileEvents.pipe(filter(f => f.item.folder.id == this.f.id && this.hasChildren)).subscribe(f => {
            if(f.event == 'ADD'){
                this.children.add(this._builder.fromFile(f.item))
            }
            else if(f.event == 'REMOVE'){
                this.children.values = this.children.values.filter(c => c.ref != f.item)
            }
        }))
 

        var folders = this.f.vasat.searchByObject(Folder)
        .equals('parent',this.f.id)
        .equals('active',true)
        .useCache(true)
        .sortBy('name')
        .queryObservable().pipe(map(r => 
            r.items.map(i => this._builder.fromFolderWithFiles(i,false,this.selectableFiles))
        ))
        var files = this.f.vasat.searchByObject(Dataset)
            .equals("folder",this.f.id)
            .equals("active",true)
            .useCache(true)
            .limit(100)
            .queryObservable().pipe(map(r => 
                r.items.map(i => {
                    return this._builder.fromFile(i,this.selectableFiles)
                })
            ))
 
            return combineLatest([folders,files]).pipe(map(([folderRes,fileRes]) => (<any[]>folderRes).concat(fileRes))).pipe(map(r => 
                this.children.values = r
            ))
    }
    get hasChildren():boolean{ return this.f['folder_count'] || this.f['file_count']}
}




class JobTypeNode extends TreeNode{
    constructor(protected jt:JobType,private mapData:MapDataService){
        super(jt.name,false,jt)
    }
    loadChildren(){
        // idea is if the tree is rendered as theres changes to a job, let this class know
        this._subs.push(this.mapData.sceneJobs.events.pipe(filter(ev => ev.item.jobType.id == this.jt.id)).subscribe(ev => {
            if(ev.event == 'ADD'){
                this.children.set(new JobNode(ev.item))
            }
            else if(ev.event == 'REMOVE'){
                var tn = this.children.values.find(v => v.ref == ev.item)
                this.children.remove(tn)
            }
            else{
                var tn = this.children.values.find(v => v.ref == ev.item)
                if(ev.item.active)
                    this.children.emmit(tn,'UPDATE')
                else
                    this.children.remove(tn)
            }

        }))
        return of(this.mapData.sceneJobs.values.filter(j => j.jobType.id == this.jt.id).map(j => this._builder.fromJob(j))).pipe(map(a => 
            this.children.values = a
        ))
    }
    get hasChildren():boolean{ return true }
}




class FileNode extends TreeNode{
    constructor(private f:Dataset,selectableFile:boolean = false){
        super(f.name,false,f,selectableFile)
    }

    get isLeaf():boolean{ return true }

}

class JobNode extends TreeNode{
    constructor(private f:Job){
        super(f.name,false,f)
    }

    get isLeaf():boolean{ return true }

}

export class TreeEvent extends BaseEvent<TreeNode,'checked'|'selected'|'unselected'|'expanded'|'collapsed'|'fetching_children'|'fetched_children'>{}

